import moment from "moment";
import { CopyTextToClipboard } from "../../helpers/copy";
import {
  DeleteOutlined,
  MoreOutlined,
  EyeOutlined,
  FormOutlined,
} from "@ant-design/icons";
import { Button, Dropdown, Space, Tooltip } from "antd";
import { t } from "i18next";

export const ColumnsRole = (
  nameMerchang,
  dropdownPlacement,
  handleShowDetail,
  handleShowEditRolePermissionsModel,
  handleDelete,
  resProfileAdmin,
  accessible_details,
  accessible_edit,
  accessible_del
) => [

    // ID
    {
      title: "ID",
      key: "id",
      dataIndex: "id",
      render: (id, record, index) => (
        <>
          <span
            className={`hover text-center`}
            onClick={() => accessible_details ? handleShowDetail(record) : alert(t("You do not have permission to view details."))}
            title="View details"
            style={{ cursor: "pointer", color: record?.id === resProfileAdmin?.roleID ? "#007bff" : "inherit" }}
          >
            <u>#{id}</u>
          </span>
        </>
      ),
    },

    // UUID
    {
      title: <span className="text-truncate">{t("UUID")}</span>,
      filterSearch: true,
      dataIndex: "UUID",
      key: "UUID",
      sorter: false,
      render: (uuid) => (
        <div className="d-flex align-items-center">
          <Tooltip placement="topLeft" color="#3eacff" title={uuid}>
            <span
              className="text-truncate"
              style={{
                textWrap: "nowrap",
                maxWidth: "150px",
                color: "#3eacff",
                display: "inline-block",
              }}
            >
              {uuid}
            </span>
          </Tooltip>
          <span className="ms-2">
            <i
              className="fa fa-copy"
              onClick={() => {
                CopyTextToClipboard(uuid);
              }}
              style={{ color: "#3eacff", fontSize: "17px", cursor: "copy" }}
            ></i>{" "}
          </span>
        </div>
      ),
    },

    // Merchant
    {
      title: t("Merchant"),
      filterSearch: true,
      sorter: false,
      render: () => <span>{nameMerchang}</span>,
    },

    // Role
    {
      title: <>{t("Role ")} <small>(system)</small></>,
      dataIndex: "name",
      key: "name",
      sorter: false,
      render: (text) => (
        <span
          style={{ maxWidth: "100%", display: "inline-block" }}
          className="text-truncate"
        >
          {text}
        </span>
      ),
    },

    // .Role Name
    {
      title: <>{t("Role Name")} <small>(Custom)</small></>,
      dataIndex: "roleName",
      filterSearch: true,
      key: "roleName",
      sorter: false,
      render: (text, record) => <span>{text}</span>,
    },

    // Created
    {
      title: t("Created At "),
      dataIndex: "createdAt",
      filterSearch: true,
      key: "createdAt",
      sorter: false,
      render: (date) => <span>{moment(date).format("YYYY-MM-DD HH:mm:ss")}</span>,
    },

    // Action
    {
      title: t("Action "),
      render: (_, record) => {

        let itemsMenu = [];

        if (accessible_details) {
          itemsMenu.push({
            key: "Details",
            icon: <EyeOutlined />,
            label: <>{t("Details")}</>,
            onClick: () => handleShowDetail(record),
          },);
        }

        if (accessible_edit) {
          itemsMenu.push({
            key: "Edit",
            icon: <FormOutlined />,
            label: <>{t("Edit")}</>,
            onClick: () => handleShowEditRolePermissionsModel(record),
          },);
        }

        if (accessible_del) {
          itemsMenu.push({
            key: "Delete",
            icon: <DeleteOutlined />,
            style: { color: record?.id === resProfileAdmin?.roleID ? "#888" : "red" },
            label: <>{t("Delete")}</>,
            disabled: record?.id === resProfileAdmin?.roleID,
            title: record?.id === resProfileAdmin?.roleID ? t("You cannot delete your own role") : "",
            onClick: () => handleDelete(record),
          },);
        }

        return <Space size="middle">
          <div className="md-show">
            {itemsMenu.length === 0 ? (null) : (<Dropdown
              arrow={true}
              trigger={["click"]}
              placement={dropdownPlacement || "bottomRight"}
              align="start"
              menu={{
                items: itemsMenu,
              }}
            >
              <Button shape="circle">
                <MoreOutlined
                  style={{ color: "#5A5A5A" }}
                  id="MoreOutlined"
                />
              </Button>
            </Dropdown>)}

          </div>
        </Space>
      },
    },
  ];
